import script from "./LanguageInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageInput.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__